import {AntibodyEnforcedNamingStrategySpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {RegistryLabelingStrategy} from 'constants/RegistryConstants';
import {NamingStrategy} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getEnabledLabelingStrategiesForSchema} from 'registry/labeling-strategies/LabelingStrategiesUtil';

export function getEnforcedNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec
): Array<RegistryLabelingStrategy> {
  return enforcedNamingStrategySpec.validNamingStrategies.map(
    (strategy) => RegistryLabelingStrategy[strategy]
  );
}

/**
 * Returns the strategies from the spec that will actually be applied to this schema — the ones that
 * are both deploy-enabled and compatible with whether the schema has a name template. These are
 * applied automatically (labeling strategies aren't user-configurable in this flow); name-template
 * strategies are excluded when hasNameTemplate is false.
 */
export function getApplicableNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec,
  hasNameTemplate: boolean
): Array<NamingStrategy> {
  const enabledStrategyValues = new Set<string>(getEnabledLabelingStrategiesForSchema(hasNameTemplate));
  return enforcedNamingStrategySpec.validNamingStrategies.filter((strategy) =>
    enabledStrategyValues.has(strategy)
  );
}

export function getShouldAddNamingStrategies(
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec,
  existingNamingStrategies: Array<RegistryLabelingStrategy> | null
): boolean {
  const enforcedStrategies = getEnforcedNamingStrategies(enforcedNamingStrategySpec);
  return (
    existingNamingStrategies == null ||
    !existingNamingStrategies.some((strategy) => enforcedStrategies.includes(strategy))
  );
}
